import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/admin_special_offer/:consignmentId/create',
    name: 'create_admin_special_offer',
    component: () => import('@/views/pages/special-offer/admin/CreateSpecialOffer.vue'),
    meta: {
      pageTitle: 'Create Special Offer',
      breadcrumb: {
        label: 'Create Special Offer',
        parent: 'admin_special_offer'
      },
      roles: [ROLES.SUPERADMIN]
    }
  },
  {
    path: '/admin_special_offer/:consignmentId/:id',
    name: 'admin_special_offer_detail',
    component: () => import('@/views/pages/special-offer/admin/EditSpecialOffer.vue'),
    meta: {
      pageTitle: 'Edit Special Offer',
      breadcrumb: {
        label: 'Edit Special Offer',
        parent: 'admin_special_offer'
      },
      roles: [ROLES.SUPERADMIN]
    }
  },
  {
    path: '/admin_special_offer',
    name: 'admin_special_offer',
    component: () => import('@/views/pages/special-offer/admin/SpecialOfferList.vue'),
    meta: {
      pageTitle: 'Special Offers',
      breadcrumb: {
        label: 'Special Offers'
      },
      roles: [ROLES.SUPERADMIN],
      verticalMenu: {
        title: 'Special Offers',
        icon: 'AwardIcon'
      }
    }
  },
  {
    path: '/special_offer',
    name: 'special_offer',
    component: () => import('@/views/pages/special-offer/customer/SpecialOfferList.vue'),
    meta: {
      pageTitle: 'Special Offers for Me',
      breadcrumb: {
        label: 'Special Offers for Me'
      },
      roles: [ROLES.SUPERADMIN],

      verticalMenu: {
        title: 'Special Offers for Me',
        icon: 'AwardIcon'
      }
    }
  }
];
